import { createSlice } from '@reduxjs/toolkit';

import { patchProjectFile } from '../project/project.thunks';

import { loadApplySync } from './sync.thunks';
import { SyncFileDescription, SyncSliceState } from './types';

import './sync.middlewares';

const initialState: SyncSliceState = {
  syncing: {},
  pending: {},
};

export const syncSlice = createSlice({
  name: 'sync',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(patchProjectFile.fulfilled, (state, action) => {
      if (!action.payload) {
        return;
      }

      const { type, baseName } = action.payload;
      const key = createSyncFileKey({ type, baseName });

      // avoid duplicates in pending
      if (state.pending[key]) {
        return;
      }

      state.pending[key] = { type, baseName };
    });
    builder.addCase(loadApplySync.pending, (state) => {
      state.syncing = Object.assign({}, state.pending);
      state.pending = {};
    });
    builder.addCase(loadApplySync.fulfilled, (state) => {
      state.syncing = {};
    });
  },
});

export const syncReducer = syncSlice.reducer;

function createSyncFileKey(file: SyncFileDescription) {
  return `${file.type}:${file.baseName}`;
}
